import request from '@/utils/request'

const applicationURL = {
  ApplicationList: '/message-push/application-list',
  PlatformList: '/message-push/platform-list',
  List: '/message-push/application-notify-list',
  Detail: '/message-push/application-notify-detail',
  Create: '/message-push/application-notify-create',
  Delete: '/message-push/application-notify-delete',
  VersionProvince: '/message-push/application-version-province'
}

// 应用列表
export function ApplicationList (data) {
  return request({
    url: applicationURL.ApplicationList,
    method: 'post',
    data
  })
}

// 平台列表
export function PlatformList (data) {
  return request({
    url: applicationURL.PlatformList,
    method: 'post',
    data
  })
}

// 应用内通知-列表
export function ApplicationNotifyList (data) {
  return request({
    url: applicationURL.List,
    method: 'post',
    data
  })
}

// 应用内通知-详情
export function ApplicationNotifyDetail (data) {
  return request({
    url: applicationURL.Detail,
    method: 'post',
    data
  })
}

// 应用内通知-创建
export function ApplicationNotifyCreate (data) {
  return request({
    url: applicationURL.Create,
    method: 'post',
    data
  })
}

// 应用内通知-删除
export function ApplicationNotifyDelete (data) {
  return request({
    url: applicationURL.Delete,
    method: 'post',
    data
  })
}

// 应用版本省份
export function VersionProvince (data) {
  return request({
    url: applicationURL.VersionProvince,
    method: 'post',
    data
  })
}

export default {
  ApplicationList,
  PlatformList,
  ApplicationNotifyList,
  ApplicationNotifyDetail,
  ApplicationNotifyCreate,
  ApplicationNotifyDelete,
  VersionProvince

}
